import React, { useState } from "react";
import { createPortal } from "react-dom";
import Icon from "../common/Icon.jsx";
import { handleCopyTextOnClick } from "../../utils/Utils";
import useDevice from "../../hooks/useDevice";
import styled from "styled-components";

const baseUrl =
  "https://travel.more.com/cmstemplates/vivatravelaspx/data/common/barcode.ashx?type=qrcode&height=140&code=";

const GovVerification = styled("div")(({ isPending }) => ({
  padding: "16px 8px",
  borderRadius: 8,
  border: isPending ? "1px solid #FCB041" : "1px solid #28BE63",
  backgroundColor: isPending ? "#FFFBF6" : "#F6FBF8",
  textAlign: "center",
}));

const Title = styled("div")(({ isPending }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 14,
  color: isPending ? "#FCB041" : "#28BE63",
  fontWeight: 600,
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  marginBottom: 4,
}));

const Image = styled("div")((props) => ({
  backgroundImage: `url(${baseUrl}${props.code})`,
  backgroundSize: "contain",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  width: "100%",
  height: 63,
  marginBottom: 8,
}));

const Description = styled("div")({
  fontSize: 14,
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  color: "#0D0C1C",
  marginBottom: 16,
});

const CodeContainer = styled("div")({
  display: "inline-flex",
  alignItems: "center",
  verticalAlign: "middle",
  marginLeft: 24,
});

const Code = styled("div")({
  fontSize: 14,
  fontWeight: 400,
  color: "#0D0C1C",
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  cursor: "default",
});

const Popup = styled("div")(({ isDesktop }) => ({
  position: "fixed",
  ...(isDesktop && { top: "32px" }),
  ...(!isDesktop && { bottom: "32px" }),
  left: "50%",
  padding: "8px 16px",
  fontFamily: `"pf_highway_sans_pro_lightRg", sans-serif`,
  backgroundColor: "#28BE63",
  color: "#fff",
  borderRadius: 8,
  fontSize: 14,
  whiteSpace: "nowrap",
  zIndex: 1000,
  transition: "opacity 0.3s ease",
  transform: "translate(-50%, 0)",
}));

const GovWalletInfo = ({ ticketId, isPending }) => {
  const qrCode = "2" + ticketId.toString().padStart(11, "0");
  const [copied, setCopied] = useState(false);
  const { isDesktop } = useDevice();

  const showPopup = () => {
    setCopied(true);
    // auto hide after 1.5s
    setTimeout(() => setCopied(false), 3000);
  };

  const BottomPopup = ({ message }) => {
    return createPortal(
      <Popup isDesktop={isDesktop}>{message}</Popup>,
      document.body
    );
  };

  const renderContent = () => {
    const content = isPending
      ? {
          icon: "pending",
          title: orderdetails_resources.PendingGovVerification,
          description: orderdetails_resources.ScanQrCodeGov,
        }
      : {
          icon: "tick",
          title: orderdetails_resources.SuccessfulGovVerification,
          description: orderdetails_resources.FindYourTicketGov,
        };

    return (
      <>
        <Title isPending={isPending}>
          <Icon kind={content.icon} />
          <div>{content.title}</div>
        </Title>
        <Description>{content.description}</Description>
      </>
    );
  };

  return (
    <GovVerification isPending={isPending}>
      {renderContent()}
      <div>
        <Image code={qrCode} />
        <Code>
          <CodeContainer>
            {qrCode}
            <div
              onClick={() => handleCopyTextOnClick(qrCode, showPopup)}
              style={{ cursor: "pointer" }}
            >
              <Icon kind="copy"></Icon>
            </div>
          </CodeContainer>
          {copied && (
            <BottomPopup message={playdetailsv2_resources.CopiedToClipboard} />
          )}
        </Code>
      </div>
    </GovVerification>
  );
};

export default GovWalletInfo;
